import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import { RiMotorbikeFill } from "react-icons/ri";
import { MdAccountBalance } from "react-icons/md";
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
} from "react-icons/md";
import { BiCategory } from "react-icons/bi";
import { IoFastFoodSharp } from "react-icons/io5";
import { FaBorderAll, FaBuilding, FaUser } from "react-icons/fa";
import { IoLogoBuffer } from "react-icons/io";
import { SiIfood } from "react-icons/si";
import { MdFoodBank } from "react-icons/md";
import { TfiAnnouncement } from "react-icons/tfi";
import { FaShop } from "react-icons/fa6";

import Order from "views/admin/Orders/Order";
import Categories from "views/admin/category/Categories";
import Food from "views/admin/Foods/Food";
import Banner from "views/admin/Banners/Banner";
import Users from "views/admin/Users/Users";
import Announcement from "views/admin/Announcement/Announcement";
import Branches from "views/admin/Branches/Branches";
import AddBranch from "views/admin/Branches/AddBranch";
import Organization from "views/admin/Organization/Organization";
import ViewFood from "views/admin/Foods/ViewFood";
import ViewBranch from "views/admin/Branches/ViewBranch";
import EditBranch from "views/admin/Branches/EditBranch";
import EditFood from "views/admin/Foods/EditFood";
import Toppings from "views/admin/Toppings/Toppings";
import ToppingView from "views/admin/Toppings/ToppingView";
import EditTopping from "views/admin/Toppings/EditTopping";
import ViewUser from "views/admin/Users/ViewUser";
import ViewOrder from "views/admin/Orders/ViewOrder";
import Riders from "views/admin/Rider/Rider";
import RiderDetail from "views/admin/Rider/RiderView";
import Deals from "views/admin/Deals/Deals";
import AddDeal from "views/admin/Deals/AddDeal";
import DealView from "views/admin/Deals/DealView";
import EditDeal from "views/admin/Deals/EditDeal";
import AddFood from "views/admin/Foods/AddFood";
import Ingredients from "views/admin/Ingredients/Ingredient";

import FloorTableScreen from "views/admin/Tables/Table";
import POSScreen from "views/pos/posScreen";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "POS",
    layout: "/pos",
    path: "pos",
    icon: <BiCategory className="h-6 w-6" />,
    component: <POSScreen />,
    secondary: true,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "categories",
    icon: <BiCategory className="h-6 w-6" />,
    component: <Categories />,
    secondary: true,
  },
  {
    name: "Food",
    layout: "/admin",
    path: "food",
    icon: <IoFastFoodSharp className="h-6 w-6" />,
    component: <Food />,
    secondary: true,
    aliases: ["/admin/viewFood/:id", "/admin/editfood/:id" , "/admin/addFood"],
  },
  {
    name: "Deals",
    layout: "/admin",
    path: "deal",
    icon: <MdFoodBank className="h-6 w-6" />,
    component: <Deals />,
    secondary: true,
    aliases: ["/admin/AddDeal" , "/admin/dealView/:id" , "/admin/editDeal/:id"],
  },
  {
    name: "Toppings",
    layout: "/admin",
    path: "topping",
    icon: <SiIfood className="h-6 w-6" />,
    component: <ToppingView />,
    secondary: true,
    aliases: ["/admin/addTopping" , "/admin/editTopping/:id"],
  },
  {
    name: "Orders",
    layout: "/admin",
    path: "orders",
    icon: <FaBorderAll className="h-6 w-6" />,
    component: <Order/>,
    secondary: true,
     aliases: ["/admin/viewOrder/:id"],
  },
  {
    name: "Inventary",
    layout: "/admin",
    path: "inventary",
    icon: <MdAccountBalance className="h-6 w-6" />,
    component: <Ingredients/>,
    secondary: true,
  },
  {
    name: "Banner",
    layout: "/admin",
    path: "banner",
    icon: <IoLogoBuffer className="h-6 w-6" />,
    component: <Banner />,
    secondary: true,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <FaUser  className="h-6 w-6" />,
    component: <Users />,
    secondary: true,
    aliases: ["/admin/viewUser/:id"],

  },
  {
    name: "Announcement",
    layout: "/admin",
    path: "announcement",
    icon: <TfiAnnouncement className="h-6 w-6" />,
    component: <Announcement />,
    secondary: true,
  },

  {
    name: "Branches",
    layout: "/admin",
    path: "branches",
    icon: <FaShop  className="h-6 w-6" />,
    component: <Branches />,
    aliases: ["/admin/addBranch", "/admin/viewBranch/:id" ,"/admin/editBranch/:id" ],
  },
  {
    name: "Tables",
    layout: "/admin",
    path: "tables",
    icon: <FaBuilding clasName="h-6 w-6" />,
    component: <FloorTableScreen />,
    // aliases: ["/admin/addBranch", "/admin/viewBranch/:id" ,"/admin/editBranch/:id" ],
  },
  {
    name: "Riders",
    layout: "/admin",
    path: "riders",
    icon: <RiMotorbikeFill  className="h-6 w-6" />,
    component: <Riders />,
    aliases: ["/admin/RiderDetail/:id" ],
  },
  {
    name: "",
    layout: "/admin",
    path: "addBranch",
    icon: <FaShop  className="h-6 w-6" />,
    component: <AddBranch />,
    showInSidebar: false,
    parent: "branches",
  },
  {
    name: "",
    layout: "/admin",
    path: "viewUser/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <ViewUser />,
    showInSidebar: false,
    parent: "User",
  },
  {
    name: "",
    layout: "/admin",
    path: "AddDeal",
    icon: <FaShop  className="h-6 w-6" />,
    component: <AddDeal />,
    showInSidebar: false,
    parent: "deal",
  },
  {
    name: "",
    layout: "/admin",
    path: "dealView/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <DealView />,
    showInSidebar: false,
    parent: "deal",
  },
  {
    name: "",
    layout: "/admin",
    path: "editDeal/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <EditDeal />,
    showInSidebar: false,
    parent: "deal",
  },
  {
    name: "",
    layout: "/admin",
    path: "addTopping",
    icon: <FaShop  className="h-6 w-6" />,
    component: <Toppings />,
    showInSidebar: false,
    parent: "topping",
  },
  {
    name: "",
    layout: "/admin",
    path: "viewFood/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <ViewFood />,
    showInSidebar: false,
    parent: "food",
  },
  {
    name: "",
    layout: "/admin",
    path: "viewOrder/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <ViewOrder />,
    showInSidebar: false,
    parent: "food",
  },
  {
    name: "",
    layout: "/admin",
    path: "editfood/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <EditFood />,
    showInSidebar: false,
    parent: "food",
  },
  {
    name: "",
    layout: "/admin",
    path: "addFood",
    icon: <FaShop  className="h-6 w-6" />,
    component: <AddFood />,
    showInSidebar: false,
    parent: "food",
  },
  {
    name: "",
    layout: "/admin",
    path: "editTopping/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <EditTopping />,
    showInSidebar: false,
    parent: "Topping",
  },
  {
    name: "",
    layout: "/admin",
    path: "viewBranch/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <ViewBranch />,
    showInSidebar: false,
    parent: "branches",
  },
  {
    name: "",
    layout: "/admin",
    path: "editBranch/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <EditBranch />,
    showInSidebar: false,
    parent: "branches",
  },
  {
    name: "",
    layout: "/admin",
    path: "RiderDetail/:id",
    icon: <FaShop  className="h-6 w-6" />,
    component: <RiderDetail />,
    showInSidebar: false,
    parent: "rider",
  },
  {
    name: "Organization",
    layout: "/admin",
    path: "organization",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Organization />,
  },
  //  {
  //   name: "Sign In",
  //   layout: "/auth",
  //   path: "sign-in",
  //   icon: <MdLock className="h-6 w-6" />,
  //   component: <SignIn />,
  // },
  
];
export default routes;
